/**
 * Resolve an icon ReactNode for a given OAuth provider id.
 */

import React from 'react';
import { GitHubIcon, GitLabIcon, GoogleIcon, BitbucketIcon } from './icons';

export const getProviderIcon = (provider: string): React.ReactNode => {
  const iconClass = 'w-8 h-8';
  const icons: Record<string, React.ReactNode> = {
    github: <GitHubIcon className={iconClass} />,
    gitlab: <GitLabIcon className={iconClass} />,
    google: <GoogleIcon className={iconClass} />,
    bitbucket: <BitbucketIcon className={iconClass} />,
  };
  return icons[provider] || <GitHubIcon className={iconClass} />;
};
